import React, {useEffect, useState} from 'react'
import * as api from '@api'
import {useQuery} from '@/hooks/useApi'
import useToast from '@/hooks/useToast'
import ErrorToast from '@components/ErrorToast'

export default function useNetworkCompaniesList(includeOwnCompany = true) {
  const {toast} = useToast()
  const [data, setData] = useState([])

  const result = useQuery('getNetworkCompanies', () => api.companies.getCompaniesList({isDropDown: true, includeOwnCompany}), {
    gcTime: 600 * 1000,
  })

  useEffect(() => {
    if (result.isSuccess && result.data) {
      const {status, error, data: responseData} = result.data
      if (status >= 400) {
        toast.custom(t => <ErrorToast t={t} error={error} />)
      } else {
        setData(responseData?.data)
      }
    }
  }, [result.isSuccess, result.data])

  return data
}
